import { useState, type FormEvent } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daf9jd9tto0ceqqnh8j0";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [placeholder, setPlaceholder] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honey = String(fd.get("contact_alt") ?? "").trim();

    const payload = new FormData();
    if (!honey) {
      const email = String(fd.get("email") ?? "");
      const nick = String(fd.get("nickname") ?? "");
      if (email) payload.append("email", email);
      if (nick) payload.append("nickname", nick);
    }

    if (honey) {
      setStatus("success");
      setPlaceholder("");
      form.reset();
      return;
    }

    setStatus("loading");
    setFormError("");
    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new URLSearchParams(payload as unknown as Record<string, string>),
      });
      const text = await res.text();
      let parsed: any = null;
      try {
        parsed = text ? JSON.parse(text) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const isSpam =
        String(serverMsg).toLowerCase().includes("spam") ||
        String(text).toLowerCase().includes("form data is spam");
      const codeOk = res.ok && parsed?.code === "OK";

      if (!res.ok || !codeOk || isSpam) {
        setStatus("error");
        setFormError(serverMsg || (res.ok ? "提交未成功，请稍后再试" : "服务暂时不可用，请稍后再试"));
        return;
      }
      setStatus("success");
      setPlaceholder("");
      form.reset();
    } catch {
      setStatus("error");
      setFormError("网络开小差了，请稍后再试一次。");
    }
  }

  return (
    <section id="subscribe" className="py-14 md:py-20">
      <div className="container-site">
        <div className="relative overflow-hidden rounded-3xl bg-primary-500 px-6 py-12 md:px-14 md:py-16">
          <div className="pointer-events-none absolute -left-10 -top-10 opacity-15">
            <i className="ri-bell-line text-[14rem] text-background-50"></i>
          </div>
          <div className="relative grid items-center gap-8 lg:grid-cols-2">
            <div>
              <span className="chip bg-background-50/20 px-4 py-1.5 text-background-50">
                <i className="ri-notification-3-line"></i> 订阅后续提醒
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                新瓜开张、重要进展
                <br />
                第一时间通知你
              </h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-background-50/90">
                留下你的常用邮箱，蹲的帖有新更新、踩的瓜有新进展，都会准时提醒你，带带不迷路。
              </p>
            </div>

            <form
              className="rounded-2xl bg-background-50 p-5 md:p-6"
              onSubmit={handleSubmit}
              data-readdy-form
              noValidate
            >
              <div className="flex flex-col gap-3">
                <div>
                  <label htmlFor="sub-nick" className="mb-1.5 block text-sm font-medium text-foreground-800">
                    你的昵称（选填）
                  </label>
                  <input
                    id="sub-nick"
                    name="nickname"
                    type="text"
                    className="field-input"
                    placeholder="怎么称呼你"
                    maxLength={30}
                  />
                </div>
                <div>
                  <label htmlFor="sub-email" className="mb-1.5 block text-sm font-medium text-foreground-800">
                    常用邮箱
                  </label>
                  <input
                    id="sub-email"
                    name="email"
                    type="email"
                    required
                    className="field-input"
                    placeholder="you@example.com"
                  />
                </div>
                {/* honeypot */}
                <div className="field-contact-wrap" aria-hidden="true">
                  <label htmlFor="contact_alt">contact_alt</label>
                  <input
                    id="contact_alt"
                    name="contact_alt"
                    type="text"
                    tabIndex={-1}
                    autoComplete="off"
                    readOnly
                    placeholder={placeholder}
                    onChange={(e) => setPlaceholder(e.target.value)}
                    onFocus={() => setPlaceholder("")}
                  />
                </div>
              </div>

              {status === "success" && (
                <p className="mt-3 rounded-lg bg-accent-100 px-3 py-2.5 text-sm text-accent-800">
                  <i className="ri-checkbox-circle-line mr-1"></i> 订阅成功，有新瓜会第一时间提醒你！
                </p>
              )}
              {status === "error" && (
                <p className="mt-3 rounded-lg bg-primary-100 px-3 py-2.5 text-sm text-primary-800">
                  <i className="ri-error-warning-line mr-1"></i> {formError}
                </p>
              )}

              <button
                type="submit"
                disabled={status === "loading"}
                className="btn mt-4 w-full bg-primary-500 px-6 py-3 text-sm text-background-50 hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
              >
                {status === "loading" ? (
                  <>
                    <i className="ri-loader-4-line animate-spin"></i> 提交中
                  </>
                ) : (
                  <>
                    <i className="ri-bell-fill"></i> 订阅更新提醒
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}